import { useTheme } from '@emotion/react';
import { Box, Grid, Stack, Typography, useMediaQuery } from '@mui/material';
import { FC, ReactEventHandler } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as IconCheck } from '../../assets/svg/checkbox-checked.svg';
import { Button } from '../../components/button';

type RebookingDecisionSummaryCardProps = {
    title: string;
    subtitle: string;
    info: string;
    toggleIntention: ReactEventHandler;
};

export const RebookingDecisionSummaryCard: FC<RebookingDecisionSummaryCardProps> = ({
    toggleIntention,
    info,
    title,
    subtitle,
}) => {
    const { palette, breakpoints } = useTheme();
    const { t } = useTranslation();
    const isSmallScreen = useMediaQuery(breakpoints.down('lg'));

    return (
        <Stack
            p={2}
            css={{
                textDecoration: 'none',
            }}
            border="1px solid"
            borderColor={palette.grey[300]}
            spacing={2}
        >
            <Grid container justifyContent="space-between" alignItems="center" rowGap={2}>
                <Grid item>
                    <Stack
                        columnGap={2}
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        direction="row"
                    >
                        <IconCheck width="44px" height="44px" />
                        <Box>
                            <Typography variant="h6" color={palette.grey[600]} mb={1}>
                                {title}
                            </Typography>
                            <Typography variant="body1">
                                <b>{subtitle}</b>
                            </Typography>
                            <Typography variant="caption" component="p" color={palette.grey[600]}>
                                {info}
                            </Typography>
                        </Box>
                    </Stack>
                </Grid>

                <Grid item xs={12} lg="auto">
                    <Button variant="text" onClick={toggleIntention} fullWidth={isSmallScreen}>
                        {t('rebooking_intention_card_button_change')}
                    </Button>
                </Grid>
            </Grid>
        </Stack>
    );
};
